import { MouseEvent, useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TGButton from 'src/components/ui/TGButton';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectCurrentUser } from 'src/modules/users/selector';
import { FlexCol } from 'src/utils/flexLayouts';
import { QUESTIONS_THIN_PARAMS_MOBILE, TEMPLATES_THIN_PARAMS_MOBILE } from '../passAudit5S/PassAudit5S.mobile';
import PassAudit5SScreenMobile from '../passAudit5S/PassAudit5SScreen.mobile';
import { fetchData } from '../store/filtersData/actions';
import { selectModelData } from '../store/filtersData/selector';
import { getAccessibleLocationIds } from '../utils/locationAccess';

const LOCATIONS_THIN_PARAMS = { 'fields[0]': 'Title' };
const DEPARTMENTS_THIN_PARAMS = { 'fields[0]': 'Title', 'fields[1]': 'User_Department' };
const AREAS_THIN_PARAMS = { 'fields[0]': 'Title' };
const PORTAL_HOST_RE = /^supply(-mobile|-preprod)?\.napitkivmeste\.ru$/i;

const DEPENDS_THIN_PARAMS = {
  'fields[0]': 'Zone',
  'fields[1]': 'TypeAudit',
  'fields[2]': 'CheckList',
  'populate[Location][fields][0]': 'Title',
  'populate[Department][fields][0]': 'Title',
  'populate[Area][fields][0]': 'Title',
};

export default function List5SAuditMobile() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentUser: any = useAppSelector(selectCurrentUser);
  const settings = useAppSelector((state: any) => selectModelData(state, 'mt-5-s-settings')) as any[];

  const [passOpen, setPassOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchData('mt-5-s-settings'));
    dispatch(fetchData('mt-locations', LOCATIONS_THIN_PARAMS, { page: 1, pageSize: 100 }));
    dispatch(fetchData('mt-departments', DEPARTMENTS_THIN_PARAMS, { page: 1, pageSize: 100 }));
    dispatch(fetchData('mt-areas', AREAS_THIN_PARAMS, { page: 1, pageSize: 200 }));
    dispatch(fetchData('mt-5-s-depends', DEPENDS_THIN_PARAMS, { page: 1, pageSize: 100000 }));
    dispatch(fetchData('mt-5-s-templates', TEMPLATES_THIN_PARAMS_MOBILE, { page: 1, pageSize: 100 }));
    dispatch(fetchData('mt-5-s-template-questions', QUESTIONS_THIN_PARAMS_MOBILE, { page: 1, pageSize: 500 }));
  }, [dispatch]);

  const guideUrl = settings?.[0]?.GuideUrl || '';

  const openGuide = (e: MouseEvent<HTMLAnchorElement>) => {
    let url: URL;
    try {
      url = new URL(guideUrl, window.location.origin);
    } catch {
      return;
    }
    const isPortal = url.origin === window.location.origin || PORTAL_HOST_RE.test(url.hostname);
    if (!isPortal) return;

    e.preventDefault();
    const documentId = url.searchParams.get('documentCard') || url.searchParams.get('documentCardMobile');
    if (documentId) {
      const next = new URLSearchParams(searchParams);
      next.set('documentCardMobile', documentId);
      setSearchParams(next);
      return;
    }
    navigate(`${url.pathname}${url.search}`);
  };

  const noLocationAccess = useMemo(() => {
    const ids = getAccessibleLocationIds(currentUser);
    return ids !== 'all' && ids.length === 0;
  }, [currentUser]);

  return (
    <FlexCol className='w-full px-4 py-5 gap-5'>
      {guideUrl ? (
        <a
          href={guideUrl}
          onClick={openGuide}
          className='text-sm font-medium text-[#012169] underline'
        >
          Руководство по проведению аудитов 5S
        </a>
      ) : (
        <span className='text-sm font-medium text-[#012169]'>
          Руководство по проведению аудитов 5S
        </span>
      )}

      <TGButton
        color='bluedark'
        type='button'
        className='w-full'
        onClick={() => setPassOpen(true)}
        disabled={noLocationAccess}
      >
        Провести аудит
      </TGButton>

      <PassAudit5SScreenMobile open={passOpen} onClose={() => setPassOpen(false)} />
    </FlexCol>
  );
}
